export default class Vector2 {
    constructor (x, y) {
        this.set(x, y);
        this._lastX = null;
        this._lastY = null;
        this._length = null;
        this.extraData = {}; // idk lol, jank convenience
    }

    get length() {
        if (this._lastX === this.x && this._lastY === this.y)
            return this._length;
        this._lastX = this.x;
        this._lastY = this.y;
        this._length = Math.sqrt(this.x * this.x + this.y * this.y);
        return this._length;
    }

    set length(val) {
        const lengthy = this.length;
        if (val > -0.005 && val < 0.005) val = 0;
        if (val === 0 || lengthy === 0) {
            this.x = 0;
            this.y = 0;
        } else {
            if (this.x !== 0) this.x = (this.x / lengthy) * val;
            if (this.y !== 0) this.y = (this.y / lengthy) * val;
        }
        this._length = val;
        this._lastX = this.x;
        this._lastY = this.y;
    }

    toString () {
        return "Vector2(" + this.x + ', ' + this.y + ")";
    }

    set (x, y) {
        this.x = x;
        this.y = y;
        return this;
    }

    clone () {
        return new Vector2(this.x, this.y);
    }
}